export default {
  dropRouteList: [],
  dropRouteStudentList: [],
  dropRouteInfo: null,
  selected: [],
  selectedBus: [],
  scheduleInfo: [],
  currentFilter: null,
  currentSort: null,
  currentPage: null
}
